import React, { useEffect, useState } from "react";
import { Dimensions, Platform, Pressable, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, } from "@voltmoney/schema";
import { ModalAlignmentEnum, SCREEN_SIZE } from '@voltmoney/types';
import BottomSheet from "../BottomSheet";
import { isMobile } from "../../stack/utils";
import { Icon } from "../../icon/Icon";
import { Typography } from "../../typography/Typography";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import SelectItemCard from "../component/SelectItemCard/SelectItemCard";
import { addCommasToNumber, getParameters, isWeb } from "../utils";
import CustomHeader from "../../customHeader/CustomHeader";
const StateSelectionPage = ({ height, data, stateValue, stateUpdateAction, triggerAction, goBackAction, needHelpAction }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalHeight, setModalHeight] = useState(424);
    const [_stateValue, setStateValue] = useState(stateValue);
    const [_showTooltip_Delhi, setShowTooltip_Delhi] = useState(false);
    const [_showTooltip_Gujarat, setShowTooltip_Gujarat] = useState(false);
    const [_showTooltip_Karnataka, setShowTooltip_Karnataka] = useState(false);
    const [_showTooltip_TN, setShowTooltip_TamilNadu] = useState(false);
    const [_showModalToolTip1, setShowModalToolTip1] = useState(false);
    const [_showModalToolTip2, setShowModalToolTip2] = useState(false);
    const [_data, setData] = useState(data);
    let isDarkMode = null;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        isDarkMode = params?.isDarkMode;
    }
    const resetToolTip = () => {
        setShowTooltip_Delhi(false);
        setShowTooltip_Gujarat(false);
        setShowTooltip_Karnataka(false);
        setShowTooltip_TamilNadu(false);
        setShowModalToolTip2(false);
        setShowModalToolTip1(false);
    };
    useEffect(() => {
        setStateValue(stateValue);
    }, [stateValue]);
    const renderToolTipCard = (state, styleObj) => {
        if (state === 'Delhi') {
            return _showTooltip_Delhi && (React.createElement(View, { style: [styles.toolTipContainer, styleObj ? styleObj.styles : styles.toolTipPosition] },
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'The stamp duty fee for Delhi ', color: ColorTokens.Grey_Charcoal, fontWeight: '700', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })),
                React.createElement(View, null,
                    React.createElement(View, { style: styles.toolTipC1 },
                        React.createElement(View, { style: styles.toolTipIconContainer },
                            React.createElement(Icon, { name: IconTokens.Dot, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(Typography, { label: 'Flat fee of ₹350.', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })))));
        }
        if (state === 'Gujarat') {
            return _showTooltip_Gujarat && (React.createElement(View, { style: [styles.toolTipContainer, styleObj ? styleObj.styles : styles.toolTipPosition] },
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'Stamp duty fee for Gujarat', color: ColorTokens.Grey_Charcoal, fontWeight: '700', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })),
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'For credit limits up to 10 crore:', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }),
                    React.createElement(View, { style: styles.toolTipC1 },
                        React.createElement(View, { style: styles.toolTipIconContainer },
                            React.createElement(Icon, { name: IconTokens.Dot, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(Typography, { label: '₹600 + 0.25% of the credit limit', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }))),
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'For credit limits exceeding 10 crore:', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }),
                    React.createElement(View, { style: styles.toolTipC1 },
                        React.createElement(View, { style: styles.toolTipIconContainer },
                            React.createElement(Icon, { name: IconTokens.Dot, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(Typography, { label: '₹600 + 0.50% of the credit limit.', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })))));
        }
        if (state === 'Karnataka') {
            return _showTooltip_Karnataka && (React.createElement(View, { style: [styles.toolTipContainer, styleObj ? styleObj.styles : styles.toolTipPosition] },
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'Stamp duty fee for Karnataka', color: ColorTokens.Grey_Charcoal, fontWeight: '700', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })),
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'For credit limits up to 10 lacs:', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }),
                    React.createElement(View, { style: styles.toolTipC1 },
                        React.createElement(View, { style: styles.toolTipIconContainer },
                            React.createElement(Icon, { name: IconTokens.Dot, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(Typography, { label: '₹400 + 0.1% of the credit limit, with a minimum of Rs. 500.', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }))),
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'For credit limits exceeding 10 lacs:', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 }),
                    React.createElement(View, { style: styles.toolTipC1 },
                        React.createElement(View, { style: styles.toolTipIconContainer },
                            React.createElement(Icon, { name: IconTokens.Dot, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(Typography, { label: '₹400 + 0.2% of the credit limit, capped at a maximum of Rs. 10 lacs.', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })))));
        }
        if (state === 'Tamil Nadu') {
            return _showTooltip_TN && (React.createElement(View, { style: [styles.toolTipContainer, styleObj ? styleObj.styles : styles.toolTipPosition] },
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'Stamp duty fee for Tamil Nadu', color: ColorTokens.Grey_Charcoal, fontWeight: '700', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })),
                React.createElement(View, null,
                    React.createElement(View, { style: styles.toolTipC1 },
                        React.createElement(View, { style: styles.toolTipIconContainer },
                            React.createElement(Icon, { name: IconTokens.Dot, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(Typography, { label: '₹100 + 0.5% of the credit limit.', color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, lineHeight: 20 })))));
        }
    };
    const handleConfirmAndPress = () => {
        resetToolTip();
        stateUpdateAction &&
            triggerAction({
                ...stateUpdateAction,
                payload: {
                    stateValue: _stateValue,
                    ...stateUpdateAction.payload
                }
            });
    };
    const handleToolTipPress = (stateName) => {
        resetToolTip();
        switch (stateName) {
            case 'Delhi':
                setShowTooltip_Delhi(!_showTooltip_Delhi);
                break;
            case 'Gujarat':
                setShowTooltip_Gujarat(!_showTooltip_Gujarat);
                break;
            case 'Karnataka':
                setShowTooltip_Karnataka(!_showTooltip_Karnataka);
                break;
            case 'Tamil Nadu':
                setShowTooltip_TamilNadu(!_showTooltip_TN);
                break;
        }
    };
    const handleDoNotChange = () => {
        resetToolTip();
        stateUpdateAction &&
            triggerAction(stateUpdateAction);
    };
    const handleHeaderAction = () => {
        goBackAction &&
            triggerAction(goBackAction);
    };
    const onSelectItem = (item) => {
        resetToolTip();
        setStateValue(item.state);
    };
    const renderCardItems = () => (React.createElement(React.Fragment, null, data &&
        Object.keys(data).map((key, index) => (React.createElement(React.Fragment, null,
            React.createElement(View, { key: `${index}+${_stateValue}`, style: {
                    paddingBottom: 8
                } },
                !showModal && renderToolTipCard(key),
                React.createElement(SelectItemCard, { isSelected: _stateValue === key, title: `${key}`, subtitle: `₹${addCommasToNumber(data[`${key}`])}`, value: {
                        state: `${key}`,
                    }, isDarkMode: isDarkMode ? true : false, onPress: (selectedItem) => onSelectItem(selectedItem), onPressToolTip: () => handleToolTipPress(key) })))))));
    const _headerChild = () => {
        return (React.createElement(Pressable, { style: styles.headerContainer, onPress: () => resetToolTip() },
            React.createElement(TouchableOpacity, { style: styles.headerBackIcon, onPress: () => handleHeaderAction() },
                React.createElement(Icon, { name: IconTokens.ChevronLeft, size: IconSizeTokens.MD })),
            React.createElement(Typography, { label: 'Select state for loan registration ', fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24 })));
    };
    const _bodyChild = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(ScrollView, { style: {
                    height: height - 128,
                    padding: 16
                } },
                React.createElement(Pressable, { style: styles.bodyContainer, onPress: () => resetToolTip() },
                    React.createElement(Typography, { label: 'Available states', fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: isDarkMode && ColorTokens.White }),
                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                    React.createElement(Typography, { label: 'Select the state for stamping and registering your loan agreement', fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal }),
                    React.createElement(Space, { size: SizeTypeTokens.XL }),
                    renderCardItems()))));
    };
    const _footerChild = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Pressable, { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: 16
                }, onPress: () => resetToolTip() },
                React.createElement(View, { style: {
                        flex: 1
                    } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Confirm and proceed', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            if (stateValue === _stateValue) {
                                handleConfirmAndPress();
                            }
                            else {
                                resetToolTip();
                                setShowModal(true);
                            }
                        } })))));
    };
    const modalContentPresenter = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Pressable, { style: styles.modalContainer, onPress: () => resetToolTip() },
                React.createElement(View, { style: styles.modalTitleContainer },
                    React.createElement(Typography, { label: `Are you sure you want to update the state to ${_stateValue}?`, fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24 })),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Typography, { label: `Previous selection`, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                _showModalToolTip1 && renderToolTipCard(stateValue, { styles: styles.toolTipPosition1 }),
                React.createElement(SelectItemCard, { isSelected: false, title: `${stateValue}`, subtitle: `₹${addCommasToNumber(data[`${stateValue}`])}`, isDisabled: true, value: undefined, isDarkMode: isDarkMode, onPress: () => resetToolTip(), onPressToolTip: () => {
                        handleToolTipPress(stateValue);
                        setShowModalToolTip1(true);
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: `Current selection`, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                _showModalToolTip2 && renderToolTipCard(_stateValue, { styles: styles.toolTipPosition2 }),
                React.createElement(SelectItemCard, { isSelected: false, title: `${_stateValue}`, subtitle: `₹${addCommasToNumber(data[`${_stateValue}`])}`, isDisabled: true, value: undefined, isDarkMode: isDarkMode, onPress: () => resetToolTip(), onPressToolTip: () => {
                        handleToolTipPress(_stateValue);
                        setShowModalToolTip2(true);
                    }, bgColor: '#F9FAFB' }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Don’t change the state', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        handleDoNotChange();
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: 'Confirm and proceed', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        handleConfirmAndPress();
                    } }))));
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 16 : height, backgroundColor: isDarkMode ? '#0D141F' :
                    'white' }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(CustomHeader, { title: "Select state for loan registration", goBackId: "btn_SelectStae_goBack", goBackAction: goBackAction, needHelpId: "btn_SelectState_needHelp", needHelpAction: needHelpAction, triggerAction: triggerAction }),
            React.createElement(View, { style: { height: height - 138 } }, _bodyChild()),
            React.createElement(View, { style: [styles.footer, { backgroundColor: isDarkMode ? '#0D141F' : 'white' }] }, _footerChild())),
        showModal &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    zIndex: 5
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: !isWeb() ? height : isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 506, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        paddingHorizontal: 16,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F3F5',
        backgroundColor: '#FFF',
        shadowOffset: { width: 0, height: 1 },
        shadowColor: 'rgba(208, 213, 221, 0.25)',
        shadowOpacity: 1,
        shadowRadius: 6,
        elevation: 1,
        height: 56,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: Platform.OS === "ios" ? 36 : 0
    },
    headerContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    headerBackIcon: {
        position: 'relative',
        top: 5,
    },
    bodyContainer: {
        width: '100%',
        height: '100%'
    },
    modalContainer: {
        padding: 16
    },
    modalTitleContainer: {
        width: '90%'
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        marginTop: Platform.OS === "ios" ? 25 : 5,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderColor: '#F2F4F7',
        borderTopWidth: 0.5,
        shadowOpacity: 0.08,
        elevation: 10,
        backgroundColor: 'white',
        shadowOffset: {
            width: 0,
            height: 0
        },
        shadowRadius: 5,
    },
    toolTipContainer: {
        position: 'absolute',
        backgroundColor: '#FFF',
        color: 'white',
        padding: 16,
        borderRadius: 6,
        width: 272,
        zIndex: 5,
        shadowColor: '#18274b',
        shadowOffset: {
            width: 0,
            height: 3,
        },
        shadowOpacity: 0.1,
        shadowRadius: 12,
        elevation: 5, // For Android shadow
    },
    toolTipPosition: {
        bottom: '80%',
        left: '50%',
        transform: [{ translateX: -99 }],
    },
    toolTipPosition1: {
        bottom: '70%',
        left: '50%',
        transform: [{ translateX: -99 }],
    },
    toolTipPosition2: {
        bottom: '45%',
        left: '50%',
        transform: [{ translateX: -99 }],
    },
    toolTipIconContainer: {
        width: 10,
        height: 10,
        position: 'relative',
        top: isWeb() ? 4 : 6,
    },
    toolTipC1: {
        display: 'flex',
        flexDirection: 'row'
    }
});
export default (StateSelectionPage);
